module.exports = {
	"MouseEvent": [
		"click",
		"mousedown",
		"mouseup",
		"mouseover",
		"mousemove",
		"mouseout"
	],
	"KeyboardEvent": [
		"keydown",
		"keyup",
		"keypress"
	],
	"MutationEvent": [
		"DOMSubtreeModified",
		"DOMNodeInserted",
		"DOMNodeRemoved",
		"DOMNodeRemovedFromDocument",
		"DOMNodeInsertedIntoDocument",
		"DOMAttrModified",
		"DOMCharacterDataModified"
	],
	"HTMLEvents": [
		"load",
		"unload",
		"abort",
		"error",
		"select",
		"change",
		"submit",
		"reset",
		"focus",
		"blur",
		"resize",
		"scroll"
	],
	"UIEvent": [
		"DOMFocusIn",
		"DOMFocusOut",
		"DOMActivate"
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/synthetic-dom-events/types.json
// module id = 146
// module chunks = 1